import { ReactComponent as IconPinToTopActive } from "@/assets/svgs/pin-to-top-active.svg";
import { ReactComponent as IconPinToTop } from "@/assets/svgs/pin-to-top.svg";
import { ToastContext } from "@/context/toast/index";
import api from "@/services/api/eclips.js";
import React, { useContext, useEffect } from "react";

export default function PinToTop({ eclipId, eclipFolderId, pinned }) {
	const { addToastMessage } = useContext(ToastContext);
	const [isPinned, setIsPinned] = React.useState(pinned);

	useEffect(() => {
		setIsPinned(pinned);
	}, [pinned]);

	const handlePin = (e) => {
		e.preventDefault();
		e.stopPropagation();
		setIsPinned(!isPinned);
		api.pinEclip(isPinned ? "unpin" : "pin", {
			eclipId,
			eclipFolderId,
		});
		addToastMessage(
			isPinned ? "Removed pin successfully" : "Pinned successfully",
			"success"
		);
	};

	return (
		<span
			className="eclip-landing_cursor-mode__pointer cursor-lg-area"
			onClick={handlePin}
		>
			{isPinned ? <IconPinToTopActive /> : <IconPinToTop />}
		</span>
	);
}
